import { ThemeToggle } from 'design-system/react';
import { useTheme } from '../../hooks';

export function DarkModeSwitchButton() {
  const { resolved, toggleTheme } = useTheme();

  return <ThemeToggle theme={resolved} onToggle={toggleTheme} />;
}
